import {
  Avatar,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React from 'react';
import { RiLogoutCircleLine } from 'react-icons/ri';
import routes from 'routes';

export default function HeaderLinks(props) {
  const { secondary } = props;
  const menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('#111812', 'white');
  const muted = useColorModeValue('#3D433E', 'whiteAlpha.800');
  const borderColor = useColorModeValue('#E8EAE8', 'rgba(139, 225, 90, 0.25)');
  const chipBg = useColorModeValue('#ffffff', 'whiteAlpha.100');
  const shadow = useColorModeValue(
    '0 8px 24px rgba(17, 24, 18, 0.08)',
    '0 8px 24px rgba(7, 50, 5, 0.25)',
  );
  const admin_data = localStorage.getItem('admin_data') || '{}';
  const name = JSON.parse(admin_data).name || 'Admin';

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/admin/auth/sign-in';
  };

  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      justify={{ base: 'space-between', md: 'flex-end' }}
      flexDirection="row"
      bg={chipBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="8px"
      ps="8px"
      pe="8px"
      borderRadius="18px"
      gap="8px"
    >
      <SidebarResponsive routes={routes} />
      <Flex align="center" gap="10px" px="6px">
        <BoxText name={name} muted={muted} textColor={textColor} />
        <Menu>
          <MenuButton p="0px">
            <Avatar
              _hover={{ cursor: 'pointer' }}
              color="white"
              name={name}
              bg="#073205"
              size="sm"
              w="40px"
              h="40px"
            />
          </MenuButton>
          <MenuList
            boxShadow={shadow}
            p="0px"
            mt="10px"
            borderRadius="16px"
            bg={menuBg}
            border="1px solid"
            borderColor={borderColor}
          >
            <Flex w="100%">
              <Text
                ps="20px"
                pt="16px"
                pb="10px"
                w="100%"
                borderBottom="1px solid"
                borderColor={borderColor}
                fontSize="sm"
                fontWeight="600"
                color={textColor}
              >
                Hey, {name}
              </Text>
            </Flex>
            <Flex flexDirection="column" p="10px">
              <MenuItem
                _hover={{ bg: '#E8F6E3' }}
                color="red.400"
                borderRadius="8px"
                px="14px"
                onClick={handleLogout}
              >
                <Icon as={RiLogoutCircleLine} me="12px" color="red.400" w="16px" h="16px" />
                <Text fontSize="sm">Log out</Text>
              </MenuItem>
            </Flex>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
}

const BoxText = ({ name, muted, textColor }) => (
  <Flex direction="column" display={{ base: 'none', md: 'flex' }} lineHeight="1.2" me="4px">
    <Text fontSize="13px" fontWeight="600" color={textColor} noOfLines={1}>
      {name}
    </Text>
    <Text fontSize="11px" color={muted}>
      Administrator
    </Text>
  </Flex>
);

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
